import gql from 'graphql-tag';

import { getSingleProp, unwrapEdges } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { COPY_SCORING_MODEL_STATUS } from 'src/data/copyScoringModel';
import { CUSTOM_DATASET_FRAGMENT } from './schema';

const QUERY = gql`
  query CustomerCustomDatasets(
    $id: ID!
    $generationTool: GenerationToolEnum
    $status: [CustomDatasetStatusEnum!]
  ) {
    customer(id: $id) {
      customDatasets(generationTool: $generationTool, status: $status) {
        edges {
          node {
            ...CustomDataset
          }
        }
      }
    }
  }
  ${CUSTOM_DATASET_FRAGMENT}
`;

export const queryCopyScoringModels = ({
  customerId,
  generationTool,
  status = COPY_SCORING_MODEL_STATUS.active,
}) =>
  apolloClient
    .query({
      query: QUERY,
      variables: { id: customerId, generationTool, status },
      fetchPolicy: 'no-cache',
    })
    .then(({ data }) => getSingleProp(data))
    .then(({ customDatasets }) => customDatasets)
    .then(({ edges }) => unwrapEdges(edges));
